import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { StockReport } from '../../interfaces/Report/StockReport/StockReport';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { SortingOrder } from '../../interfaces/SortingOrder';
import { StockReportOrderField } from '../../interfaces/Report/StockReport/StockReportFilter';

const columns: TableColumn<StockReport>[] = [
  {
    id: 'product-name',
    name: 'Ürün Adı',
    sortable: true,
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'option-name',
    name: 'Varyant',
    accessor: (row) => <TextColumn value={row.optionName ?? ''} />,
  },
  {
    id: 'quantity',
    name: 'Stok Miktarı',
    sortable: true,
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'in-stock',
    name: 'Stok Müsaitliği',
    accessor: (row) => <BoolColumn value={row.inStock} />,
  },
  {
    id: 'status',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
  },
];

type StockReportTableProps = {
  rows: StockReport[];
  totalCount: number;
  orderBy: StockReportOrderField;
  order: SortingOrder;
  onChangeOrder: (orderBy: StockReportOrderField, order: SortingOrder) => void;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const StockReportTable = (props: StockReportTableProps) => {
  const handleClick = (productID: number) => {
    const url = `/products/catalog/${productID}`;
    window.open(url, '_blank');
  };

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.rows}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      orderBy={props.orderBy}
      order={props.order}
      onOrder={(newOrderBy, newOrder) =>
        props.onChangeOrder(newOrderBy as StockReportOrderField, newOrder)
      }
      onClick={(row) => handleClick(row.productID)}
    />
  );
};
